module.exports = __webpack_public_path__ + "img/back2.f498f4de.png";